<template>
  <Page>
	  <div class="home">
		  <b-jumbotron type="dark" class="home__jumbotron">
			  
			  <template #header><span class="jumbotron__name">Замечательные кривые</span></template>
			
			  <template #lead>
				
				  Справочник по кривым, встречающимся в математике и её приложениях, с интерактивными графиками и примерами задач
			  </template>
			
			
			
			  <b-button variant="dark" href="/about" class="home__info">Читать описание</b-button>
			  <b-button variant="success" href="#curves_card" class="home__button">Перейти к изучению кривых</b-button>
		
		  </b-jumbotron>
		  <b-container fluid id="curves_card">
			  <b-row class="justify-content-center">
				  <b-col>
					 
				  </b-col>
			  </b-row>
			  <b-row class="justify-content-center">
				  <b-col md="4" xl="3">
					  <b-card
							  title="Спираль Архимеда"
							  tag="article"
							  style="max-width: 20rem;"
							  class="mb-2 home__card"
					  >
						  <img src="@/assets/img/archimed_curve.png" class="card__photo">
						  <b-button href="/archimedes" variant="dark" class="home__button">Изучать</b-button>
					  </b-card>
				  </b-col>
				  <b-col md="4" xl="3">
					  <b-card
							  title="Гиперболическая спираль"
							  tag="article"
							  style="max-width: 20rem;"
							  class="mb-2 home__card"
					  >
						  <img src="@/assets/img/hyperbolic_curve.png" class="card__photo">
						  <b-button href="/hyperbolic_spiral" variant="dark" class="home__button">Изучать</b-button>
					  </b-card>
				  </b-col>
				  <b-col md="4" xl="3">
					  <b-card
							  title="Логарифмическая спираль"
							  tag="article"
							  style="max-width: 20rem;"
							  class="mb-2 home__card"
					  >
						  <img src="@/assets/img/logarithmic_curve.png" class="card__photo">
						  <b-button href="/logarithmic_spiral" variant="dark" class="home__button">Изучать</b-button>
					  </b-card>
				  </b-col>
				  <b-col md="4" xl="3">
					  <b-card
							  title="Лемниската Бернулли"
							  tag="article"
							  style="max-width: 20rem;"
							  class="mb-2 home__card"
					  >
						  <img src="@/assets/img/lemniscata_curve.png" class="card__photo">
						  <b-button href="/lemniscata_bernoulli" variant="dark" class="home__button">Изучать</b-button>
					  </b-card>
				  </b-col>
				
				  <b-col md="4" xl="3">
					  <b-card
							  title="Улитка Паскаля"
							  tag="article"
							  style="max-width: 20rem;"
							  class="mb-2 home__card"
					  >
						  <img src="@/assets/img/limacon_curve.png" class="card__photo">
						  <b-button href="/limacon" variant="dark" class="home__button">Изучать</b-button>
					  </b-card>
				  </b-col>
				
				  <b-col md="4" xl="3">
					  <b-card
							  title="Роза"
							  tag="article"
							  style="max-width: 20rem;"
							  class="mb-2 home__card"
					  >
						  <img src="@/assets/img/rose_curve.png" class="card__photo">
						  <b-button href="/roses" variant="dark" class="home__button">Изучать</b-button>
					  </b-card>
				  </b-col>
				  <b-col md="4" xl="3">
					  <b-card
							  title="Строфоида"
							  tag="article"
							  style="max-width: 20rem;"
							  class="mb-2 home__card"
					  >
						  <img src="@/assets/img/strophoid_curve.png" class="card__photo">
						  <b-button href="/strophoid" variant="dark" class="home__button">Изучать</b-button>
					  </b-card>
				  </b-col>
				  <b-col md="4" xl="3">
					  <b-card
							  title="Эпициклоида"
							  tag="article"
							  style="max-width: 20rem;"
							  class="mb-2 home__card"
					  >
						  <img src="@/assets/img/epicycloid_curve.png" class="card__photo">
						  <b-button href="/epicycloid" variant="dark" class="home__button">Изучать</b-button>
					  </b-card>
				  </b-col>
				  <b-col md="4" xl="3">
					  <b-card
							  title="Кардиоида"
							  tag="article"
							  style="max-width: 20rem;"
							  class="mb-2 home__card"
					  >
						  <img src="@/assets/img/cardioid_curve.png" class="card__photo">
						  <b-button href="/cardioid" variant="dark" class="home__button">Изучать</b-button>
					  </b-card>
				  </b-col>
				  <b-col md="4" xl="3">
					  <b-card
							  title="Астроида"
							  tag="article"
							  style="max-width: 20rem;"
							  class="mb-2 home__card"
					  >
						  <img src="@/assets/img/astroid_curve.png" class="card__photo">
						  <b-button href="/astroid" variant="dark" class="home__button">Изучать</b-button>
					  </b-card>
				  </b-col>
			  </b-row>
		  </b-container>
	  </div>
  </Page>
</template>

<script>
import Page from '@/views/templates/Page'
export default {
  name: 'Home',
  components: {
  	Page
  }
}
</script>

<style scoped lang="scss">
	.home__jumbotron {
		width: 100%;
		margin-top: -35px;
		box-shadow: 0 0 4px black;
		position: relative;
		z-index: 0;
		overflow: hidden;
		h1{
			width: 100%;
			@media (max-width: 900px){
				font-size: 50px;
			}
			@media (max-width: 600px){
				font-size: 30px;
			}
			
		}
		.lead {
			@media (min-width: 900px){
				font-size: 28px;
			}
		}
	}
	.home__button {
		margin: 10px;
	}
	.home__card {
		box-shadow: 4px 4px 4px lightgray;
		margin-left: auto;
		margin-right: auto;
		margin-top: 20px;
		.card__photo {
			width: 100%;
		}
		.home__button {
			width: 100%;
		  margin-top: 20px;
			margin-left: auto;
			margin-right: auto;
		}
	}
	
</style>
